<template>
  <div class="setting-join-index">
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'setting-join-index',
    watch: {
    	$route(to, from) {
    	  console.log('change')
    	  document.body.scrollTop = 0
    	}
    },
  }
</script>

<style lang="scss">

</style>
